// AI model providers: the part of an OpenRouter model id before the slash
// ("openai/gpt-4o" -> "openai"). A super admin may restrict the providers a
// company can use; null or an empty list means every provider is allowed.

export const providerOf = (modelId: string): string =>
  (modelId.includes('/') ? modelId.split('/')[0] : modelId).trim().toLowerCase();

export function isModelAllowed(modelId: string, allowed: string[] | null | undefined): boolean {
  if (!allowed || allowed.length === 0) return true;
  return allowed.map((p) => p.toLowerCase()).includes(providerOf(modelId));
}

/** Unique providers of a model list, alphabetically. */
export function providersFromModels(modelIds: string[]): string[] {
  return [...new Set(modelIds.map(providerOf).filter(Boolean))].sort();
}

const PROVIDER_LABELS: Record<string, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  google: 'Google',
  'meta-llama': 'Meta',
  mistralai: 'Mistral',
  'x-ai': 'xAI',
  deepseek: 'DeepSeek',
  qwen: 'Qwen',
  cohere: 'Cohere',
  perplexity: 'Perplexity',
  amazon: 'Amazon',
  microsoft: 'Microsoft',
};

export const providerLabel = (provider: string): string => PROVIDER_LABELS[provider] ?? provider;
